import type { UseControllerProps } from 'react-hook-form'

import React from 'react'
import { useFormContext } from 'react-hook-form'

import { Checkbox } from '@/shared/components/ui/checkbox-native'
import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
} from '@/shared/components/ui/form'

import { FieldContent } from '../ui/field'

export default function RHFCheckbox({
	name,
	label,
	rules,
	shouldUnregister,
	defaultValue,
	description,
	disabled,
}: UseControllerProps & { label?: string; description?: string }) {
	const { control } = useFormContext()

	return (
		<FormField
			name={name}
			rules={rules}
			shouldUnregister={shouldUnregister}
			defaultValue={defaultValue}
			control={control}
			render={({ field }) => (
				<FormItem orientation='horizontal'>
					<FormControl>
						<Checkbox
							ref={field.ref}
							disabled={disabled}
							checked={field.value}
							onChange={field.onChange}
						/>
					</FormControl>
					<FieldContent>
						<FormLabel>{label}</FormLabel>
						{!!description && <FormDescription>{description}</FormDescription>}
					</FieldContent>
				</FormItem>
			)}
		/>
	)
}
